import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import { Notification, RadioGroup, Spacer } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../../../../../context/LocalizedStringsContext';

const TankProduct = ({
  typeKey,
  dataField,
  setDataField,
  fieldOptions,
  error
}) => {
  const {
    iotOrderDetailsSection: {
      nssFarmAndRanchTankDetailsLabel: { tankProduct }
    },
    modalForm: { fieldRequiredMessage }
  } = useLocalizedStringsContext();

  const fieldHasError = error && !dataField.valueTankProduct;
  const otherFieldHasError =
    error &&
    dataField.valueTankProduct === 'Other' &&
    !dataField.valueTankProductOther;

  useEffect(() => {
    if (fieldOptions.length === 1 && !dataField.valueTankProduct) {
      setDataField(previousValue => ({
        ...previousValue,
        valueTankProduct: fieldOptions[0]
      }));
    }
  }, [dataField]);

  const radioItems = fieldOptions.map(option => ({
    label: option,
    id: option
  }));

  return (
    <>
    <Spacer space={4} />
      <RadioGroup
        legend={tankProduct}
        items={radioItems}
        checkedId={dataField.valueTankProduct || null}
        onChange={(value) => setDataField({
          ...dataField,
          valueTankProduct: value
        })}
        name={`${typeKey}--tank-product`}
        validation={fieldHasError ? 'error' : undefined}
        feedback={fieldHasError ? fieldRequiredMessage : undefined}
      />
      {dataField.valueTankProduct === 'Other' && (
        <input
          type="text"
          className={`tank-details__other-product ${otherFieldHasError &&
            'error'}`}
          placeholder="product.."
          value={dataField.valueTankProductOther}
          onChange={e =>
            setDataField({
              ...dataField,
              valueTankProductOther: e.target.value
            })
          }
        />
      )}
      {otherFieldHasError && (
        <div style={{ marginTop: '5px' }}>
          <Notification variant={{ validation: 'error' }}>
            {fieldRequiredMessage}
          </Notification>
        </div>
      )}
      <Spacer space={2} />
    </>
  );
};

TankProduct.propTypes = {
  typeKey: PropTypes.string.isRequired,
  dataField: PropTypes.shape({
    valueTankNumber: PropTypes.string,
    valueTankName: PropTypes.string,
    valueTankProduct: PropTypes.string,
    valueTankProductOther: PropTypes.string,
    valueTankType: PropTypes.string,
    valueTankHeight: PropTypes.string,
    valueTankLength: PropTypes.string,
    valueTankCapacity: PropTypes.string,
    valueTankMaterial: PropTypes.string,
    valueTankSensorType: PropTypes.string,
    valueTankPortSize: PropTypes.string,
    valueTankOptionalStand: PropTypes.string
  }).isRequired,
  setDataField: PropTypes.func.isRequired,
  fieldOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  error: PropTypes.string.isRequired
};

export default TankProduct;
